import { gql } from "@apollo/client";

const ACCEPT_WHATSAPP_CALL = gql`
  mutation acceptWhatsAppCall($callId: String!, $sdpAnswer: String!) {
    acceptWhatsAppCall(callId: $callId, sdpAnswer: $sdpAnswer) {
      id
      callId
      status
      sdpAnswer
    }
  }
`;

export default ACCEPT_WHATSAPP_CALL;
